import {connect} from "react-redux";
import {otpFocusAfterFail, otpFormReset, verifyOtp} from "./authWithOtp/redux2";
import React from "react";
import PropTypes from "prop-types";
import Layout from './Layout';
import {OtpTooManyAttempts} from "./OtpTooManyAttempts";
import {replace} from "react-router-redux";
import registerUrl from "../utils/url/registerUrl";
import {OtpForm} from "./OtpForm";
import LoadingBlocking from "../components/loading/LoadingBlocking";
import reduxRouteChanged from "../services/reduxRouteChanged";
import {createPasswordUrl} from "../utils/url/createPasswordUrl";
import {datadogRum} from "@datadog/browser-rum";
import loginUrl from "../utils/url/loginUrl";
import {registerOtpTypeUrl} from "../utils/url/registerOtpTypeUrl";
import {OTP_ACTIVITY_BLOCKED_UNTIL} from "./authWithOtp/constants2";
import {otpSuccessDelayTime} from "../constants/contants";
import mixpanelService from '../services/mixpanel';

@connect(
  state => {
    return {
      phoneLast4digits: state.authRoot.register.phoneLast4digits,
      otpType: state.authRoot.register.otpType,
      otpTypeToken: state.authRoot.register.otpTypeToken, // token received after user picked otp type
      isSuccess: state.authRoot.register.isOtpSuccess,
      isLoading: state.authRoot.register.isLoadingOtp,
      isFail: state.authRoot.register.isOtpFail,
      otpVerifyError: state.authRoot.register.otpVerifyError,
      otpAttempts: state.authRoot.register.otpAttempts,
    };
  },
  dispatch => ({
    redirect: (path) => dispatch(replace(path)),
    verifyOtp: (verificationCode, token) => dispatch(verifyOtp(verificationCode, token)),
    otpFocusAfterFail: () => dispatch(otpFocusAfterFail()),
  })
)
class OtpRegisterController extends React.Component {

  static propTypes = {
    phoneLast4digits: PropTypes.string,
    otpTypeToken: PropTypes.string,
    verifyOtp: PropTypes.func.isRequired,
    otpFocusAfterFail: PropTypes.func.isRequired,
    redirect: PropTypes.func.isRequired,
    otpType: PropTypes.string,
    isSuccess: PropTypes.bool,
    isLoading: PropTypes.bool,
    isFail: PropTypes.bool,
    otpVerifyError: PropTypes.object,
    otpAttempts: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      lastSendVerificationCode: undefined,
      isBlocked: false,
      blockedUntil: undefined,
    };
  }

  componentDidMount() {
    if (!this.props.otpTypeToken) {
      this.props.redirect(loginUrl());
    }
  }

  navigateToRegister() {
    this.props.redirect(registerUrl());
  }

  sendAgain() {
    this.props.redirect(registerOtpTypeUrl());
  }

  onOtpComplete(verificationCode) {
    this.setState(state => {
      return {
        ...state,
        lastSendVerificationCode: verificationCode,
      };
    });
    this.props.verifyOtp(verificationCode, this.props.otpTypeToken);
  }

  componentDidUpdate(prevProps) {
    const { isSuccess, isFail, redirect, otpAttempts, otpType, otpVerifyError } = this.props;
    if (!prevProps.isSuccess && isSuccess) {
      datadogRum.addUserAction('Sign up OTP verification success', {});
      mixpanelService.track('OTP sign up', {step: 'verify otp success'});
      setTimeout(() => {
        redirect(createPasswordUrl());
      }, otpSuccessDelayTime);
    }
    if (!prevProps.isFail && isFail) {
      const dataDogFailContext = { otpType: otpType, otpAttempts: otpAttempts, verificationCode: this.state.lastSendVerificationCode, otpVerifyError };
      if (otpAttempts >= 6) {
        datadogRum.addUserAction('Sign up OTP verification failed in 6th attempt', dataDogFailContext);
        mixpanelService.track('OTP sign up', {step: 'verify otp failed in 6th attempt'});
        // todo: move the user to block page
      } else {
        datadogRum.addUserAction('Sign up OTP verification failed', dataDogFailContext);
        mixpanelService.track('OTP sign up', {step: 'verify otp failed'});
      }
      this.setState(state => {
        return {
          ...state,
          lastSendVerificationCode: undefined,
        };
      });
      if (otpVerifyError.code === OTP_ACTIVITY_BLOCKED_UNTIL) {
        this.setState(state => {
          return {
            ...state,
            isBlocked: true,
            blockedUntil: +otpVerifyError.message,
          };
        });
      }
    }
  }

  render() {
    return (
      <Layout>
        {(this.props.isLoading) && <LoadingBlocking/>}

        {!this.state.isBlocked && <OtpForm phone={this.props.phoneLast4digits ? `(***) *** - ${this.props.phoneLast4digits}` : ''}
                                           isFail={this.props.isFail}
                                           isSuccess={this.props.isSuccess}
                                           sendAgain={() => this.sendAgain()}
                                           otpComplete={(verificationCode) => this.onOtpComplete(verificationCode)}
                                           otpFocusAfterFail={this.props.otpFocusAfterFail}/>}

        {this.state.isBlocked && <OtpTooManyAttempts timeLeft={this.state.blockedUntil}
                                                     onTimerEnd={() => this.navigateToRegister()}/>}
      </Layout>
    );
  }
}


function initStore(dispatch) {
  return dispatch(otpFormReset());
}

export default reduxRouteChanged(initStore,  OtpRegisterController);



// WEBPACK FOOTER //
// ./src/auth/OtpRegisterController.js